import React from 'react';
import { Grid } from 'semantic-ui-react';
import styles from '../Financial.scss';

export default () => (
  <Grid className={styles.tableHeader}>
    <Grid.Row only='computer tablet'>
      <Grid.Column width={6}>
        <strong>Invoice</strong>
      </Grid.Column>
      <Grid.Column width={4}>
        <strong>Status</strong>
      </Grid.Column>
      <Grid.Column width={3} textAlign='right'>
        <strong>Invoice Total</strong>
      </Grid.Column>
      <Grid.Column width={3} textAlign='right'>
        <strong>Remaining Balance</strong>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);



// WEBPACK FOOTER //
// ./webpack/components/Financial/Invoices/InvoiceListHeader.js